import ScooterSettingsModal from './ScooterSettingsModal';

export default ScooterSettingsModal;
